import { render, staticRenderFns } from "./StartGuide.vue?vue&type=template&id=4dba7fe4&scoped=true&"
import script from "./StartGuide.vue?vue&type=script&lang=js&"
export * from "./StartGuide.vue?vue&type=script&lang=js&"
import style0 from "./StartGuide.vue?vue&type=style&index=0&id=4dba7fe4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba7fe4",
  null
  
)

export default component.exports